// extracted by mini-css-extract-plugin
export default {"main_content":"Main_main_content__INEHz","left":"Main_left__0htqF","tagline":"Main_tagline__YiIYV","right":"Main_right__MODP9"};